import React, { useEffect, useState } from 'react';
import { Container, Card, CardBody, Button } from 'reactstrap';
import { DataTable, Column } from 'vivace-fluent-motion';
import IntlMessage from "../../../../helpers/intlMessage";

function Grid({
  lista,
  pagina,
  totalItens,
  totalItensPage,
  setPagina,
  onClickLine,
  onClickImprimirLaudo
}) {

  const [list, setList] = useState(lista);

  useEffect(()=>{
    setList(lista);
  }, [lista]);

  function Footer({ totalItens }) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItens: 'center'
        }}
      >
        <span
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItens: 'center'
          }}
        >
          <i
            className='mv-basico-stacktrace'
            style={{ fontSize: '20px', height: '18px' }}
          />{' '}
          <span style={{ marginTop: '2px' }}>
            <IntlMessage id = "dashboards.reports.examCID"/> {totalItens}
          </span>
        </span>
      </div>
    );
  }
  return (
    <Card>
      <CardBody>
        <Container fluid>
          <DataTable
            onContextMenu={(e, item) => onClickLine(e, item)}
            value={list}
            responsive={true}
            selectionMode='single'
            style={{ height: '100%' }}
            columnResizeMode='expand'
            scrollable={true}
            scrollWidth='100%'
            resizableColumns={list.length >= 1}
            reorderableColumns={list.length >= 1}
            first={(pagina - 1) * totalItensPage}
            rows={totalItensPage}
            lazy={true}
            paginator={list.length > 0}
            emptyMessage={<IntlMessage id = "dashboards.reports.noResultsFound"/>}
            alwaysShowPaginator={false}
            autoLayout={true}
            totalRecords={totalItens}
            onPage={event => setPagina(event.page + 1)}
            footer={<Footer totalItens={totalItens} />}
          >
              <Column 
              sortable={false} 
              field='select' 
              style={{ width: '25px' }} 
              />
              <Column 
              field='laudo' 
              style={{ width: '100px' }} 
              header={<IntlMessage id = "dashboards.general.report"/>}
              />
              <Column 
              field='nrExame'
              style={{ width: '100px' }} 
              header={<IntlMessage id = "dashboards.reports.exam"/>} 
              />
              <Column 
              field='pacienteNome' 
              style={{ width: '100px' }} 
              header={<IntlMessage id = "dashboards.reports.patientCivilRegistry"/>}
              />
            <Column 
            field='solicitanteNome' 
            style={{ width: '100px' }} 
            header={<IntlMessage id = "general.requestsPanel.requester"/>}
             />
            <Column
              field='prontuario'
              style={{ width: '100px' }}
              header={<IntlMessage id = "dashboards.reports.medicalRecord"/>}
            /> 
            <Column
              field='dataPedido'
              style={{ width: '100px' }}
              header={<IntlMessage id = "dashboards.reports.dateRequest"/>}
            />
            <Column
              field='dataFinal'
              style={{ width: '100px' }}
              header={<IntlMessage id = "dashboards.reports.lastDate"/>}
            />
            <Column
              field={e => (
                <Button
                  color='link'
                  className='btn btn-imprimir'
                  onClick={() => onClickImprimirLaudo(e)}
                >
                  <i className='icons-btn mv-basico-imprimir'></i> 
                  <IntlMessage id = "dashboards.reports.printOut"/>
                </Button>
              )}
              style={{ width: '100px' }}
              header={<IntlMessage id = "dashboards.reports.notifications"/>}
            />
          </DataTable>
        </Container>
      </CardBody>
    </Card>
  );
}

export default Grid;



// WEBPACK FOOTER //
// ./src/pages/relatorio/LaudoSemCid/Grid/index.js